module.exports = __webpack_public_path__ + "img/tizen-desktop.63314d0d.webp";